export default {
  text: '#111',
  primary: '#d0bb0e',
  secondary: '#cabdb6',
  background: '#f7f7f7',
  backgroundSecondary: '#f7f7f7',
  light: '#fff',
  dark: '#111'
}
